export default __webpack_public_path__ + "static/media/cart-close.b9c7f59b.png";